module.exports = __webpack_public_path__ + "static/media/24.6364e3ee.mp3";